import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export default function FinalCTASection() {
  return (
    <section className="mx-auto max-w-7xl px-6 pb-24 pt-8 md:px-10">
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="rounded-3xl bg-gradient-to-r from-indigo-600 to-cyan-500 p-10 text-center text-white shadow-2xl"
      >
        <h2 className="mb-3 text-3xl font-bold">Start Tracking Your Health Smarter Today</h2>
        <p className="mb-6 text-indigo-50">
          Turn scattered reports into one intelligent health timeline.
        </p>
        <Link
          to="/register"
          className="inline-flex rounded-2xl bg-white px-6 py-3 text-sm font-semibold text-indigo-600 transition hover:-translate-y-0.5"
        >
          Get Started Free
        </Link>
      </motion.div>
    </section>
  );
}
